(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ethniq-recommended-products"] && !Shopify.designMode) return;
  try {
    
  const container = document.querySelector('.ethniq-recommend');
  if (container) {
    const grid = container.querySelector('.ethniq-rec-grid');
    fetch(grid.dataset.url)
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const recommendations = doc.querySelector('.ethniq-rec-grid');
        if (recommendations && recommendations.innerHTML.trim() !== '') {
          grid.innerHTML = recommendations.innerHTML;
        }
      });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
